export const noop = (...args: any[]) => null;

export const classNames = (...classes: any[]) =>
    classes.filter(Boolean).join(' ');

export const getQueryString = (filters: any) => {
    return Object.keys(filters)
        .map((key) => `${key}=${filters[key] ? filters[key] : ''}`)
        .join('&');
};

export const formatFecha = (fecha: any) => {
    const fragmentos = fecha.split('-');
    return `${fragmentos[2]}/${fragmentos[1]}/${fragmentos[0]}`;
}

export const estatusColor = (item: any) => {
    switch (item.estado) {
        case 'PENDIENTE':
            return '#C9C9C990';
        case 'ASIGNADO':
            return '#7BC0D090';
        case 'PROCESO':
            return '#D0B87B90';
        case 'FINALIZADO':
            return '#7DD07B90';
        case 'CERRADO':
            return '#D07B7B90';
        default:
            return '#C9C9C990';
    }
};

export const estatusCardColor = (item: any) => {
    switch (item?.estado || item) {
        case 'CANCELADO':
            return 'bg-pendiente';
        case 'CONFIRMADO':
            return 'bg-asignado';
        case 'PENDIENTE':
            return 'bg-danger   ';
        case 'FINALIZADO':
            return 'bg-finalizado';
        case 'CERRADO':
            return 'bg-cerrado';
        case 'LEAD':
            return 'bg-pendiente';
        case 'CLIENTE':
            return 'bg-cerrado';
        default:
            return 'bg-pendiente';
    }
};

export const estatusTextColor = (item: any) => {
    switch (item?.estado) {
        case 'PENDIENTE':
            return '#545454';
        case 'ASIGNADO':
            return '#2F7781';
        case 'PROCESO':
            return '#B9772B';
        case 'FINALIZADO':
            return '#2F8133';
        case 'CANCELADO':
            return '#950F0F';
        case 'LEAD':
            return '#545454';
        case 'CLIENTE':
            return '#950F0F';
        default:
            return '#545454';
    }
};

export const estatusTextColorRendered = (item: any) => {
    switch (item?.estado || item) {
        case 'CANCELADO':
            return 'text-[#545454]';
        case 'CONFIRMADO':
            return 'text-[#FFFFFF]';
        case 'PENDIENTE':
            return 'text-[#FFFFFF]';
        case 'FINALIZADO':
            return 'text-[#2F8133]';
        case 'CERRADO':
            return 'text-[#950F0F]';
        case 'LEAD':
            return 'text-[#545454]';
        case 'CLIENTE':
            return 'text-[#950F0F]';
        default:
            return 'text-[#545454]';
    }
};

export const transformarFechaYHora = (fechaString: string, horaString: string) => {
    // Parsear la fecha y la hora
    const fecha = new Date(fechaString);
    const hora = horaString.split(':').map(Number);

    // Establecer la hora en el objeto Date
    fecha.setHours(hora[0]);
    fecha.setMinutes(hora[1]);


    // Obtener la diferencia horaria actual
    const offset = fecha.getTimezoneOffset();

    // Formatear la fecha y hora en el formato deseado
    const fechaFormateada = fecha.toISOString().split('T')[0];
    const horaFormateada = horaString + ':00';
    const offsetFormateado = (offset > 0 ? '-' : '+') + Math.abs(offset / 60).toString().padStart(2, '0') + ':00';

    // Concatenar la fecha, la hora y el offset para obtener el formato completo
    return `${fechaFormateada}T${horaFormateada}${offsetFormateado}`;
}

export const obtenerHoraDesdeFecha = (fecha: string) => {
    const fechaObj = new Date(fecha);
    const hora = fechaObj.getHours().toString().padStart(2, '0');
    const minutos = fechaObj.getMinutes().toString().padStart(2, '0');
    return `${hora}:${minutos}`;
}

export const getFormattedDate = () => {
    // Obtén la fecha y hora actuales
    const now = new Date();

    // Obtén la diferencia de la zona horaria en minutos y conviértela en horas y minutos
    const timezoneOffset = -now.getTimezoneOffset();
    const sign = timezoneOffset >= 0 ? '+' : '-';
    const hours = String(Math.floor(Math.abs(timezoneOffset) / 60)).padStart(2, '0');
    const minutes = String(Math.abs(timezoneOffset) % 60).padStart(2, '0');

    // Formatea la fecha en el formato deseado
    const formattedDate = now.toISOString().split('.')[0] + sign + hours + ':' + minutes;

    return formattedDate;
}

export const formatDateTime = (isoString: string): string => {
    const date = new Date(isoString);
    
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    
    return `${day}/${month}/${year} ${hours}:${minutes}`;
};
